// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teamList_root__1semP {\n  height: calc(100% - 96px);\n  overflow: hidden; }\n  .teamList_root__1semP .teamList_loadingContainer__vItPV {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n", ""]);
// Exports
exports.locals = {
	"root": "teamList_root__1semP",
	"loadingContainer": "teamList_loadingContainer__vItPV"
};
module.exports = exports;
